// extracted by mini-css-extract-plugin
export default {"productCarousel":"Z0-z"};